import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";

const OptionSelect = ({
  value,
  onChange,
  options = [],
  placeholder = "Select Type",
}) => {
  return (
    <Select value={value} onValueChange={onChange} className="focus-visible:ring-0 focus-visible:border-input">
      <SelectTrigger className="w-full border-input bg-background text-foreground text-sm focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent className="bg-popover text-popover-foreground">
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value} className="hover:bg-accent hover:text-accent-foreground cursor-pointer">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default OptionSelect;
